import type { FC, ReactNode } from 'react'
import type { Service } from '@/constants/home'

import { Reveal } from '@/components/motion/reveal'
import { SectionHeading } from '@/components/site/section-heading'
import { services } from '@/constants/home'

interface ServiceCardProps {
    service: Service
    delay?: number
}

const ServiceCard: FC<ServiceCardProps> = ({ service, delay = 0 }): ReactNode => {
    return (
        <Reveal className='flex min-w-0 flex-1' delay={delay} y={20}>
            <article className='flex flex-1 items-start gap-2.5 text-foreground'>
                <p className='t-number whitespace-pre'>
                    {service.number}
                </p>

                <div className='flex min-w-0 flex-1 flex-col gap-2'>
                    <h3 className='t-lead text-left'>
                        {service.title}
                    </h3>

                    <ul className='flex flex-col gap-0.5'>
                        {service.items.map((item) => (
                            <li key={item} className='t-body text-left text-muted-foreground'>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </article>
        </Reveal>
    )
}

export const HomeServices: FC = (): ReactNode => {
    const [first, second, third, fourth] = services

    return (
        <section
            id='services'
            className='relative z-[2] flex w-full flex-col items-center overflow-clip bg-background px-4 pb-section-sm pt-section-lg lg:px-6'
        >
            <SectionHeading lead="What I" title="do" align='right' className='relative z-[2]' />

            <div className='flex w-full items-start gap-6 lg:gap-12'>
                <div className='flex w-full items-start gap-12 py-6 md:max-w-[50%] md:flex-1 md:gap-6 lg:gap-12'>
                    <ServiceCard service={first} />
                    <ServiceCard service={second} delay={0.08} />
                </div>

                <div aria-hidden='true' className='hidden flex-1 self-stretch md:block' />
            </div>

            <div className='flex w-full items-start justify-end gap-6 lg:gap-12'>
                <div aria-hidden='true' className='hidden flex-1 self-stretch md:block' />

                <div className='flex w-full items-start gap-6 py-6 md:max-w-[50%] md:flex-1'>
                    <ServiceCard service={third} />
                    <ServiceCard service={fourth} delay={0.08} />
                </div>
            </div>
        </section>
    )
}
